<template>
    <TableFilter :scheme-type="enumDef.filterSchemeType.SellerAllReceivables"
                 :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
        <div class="filter_item">
            <div class="filter_head">{{this.$t("common.receivableDetails")}}</div>
            <EnumFilter :label-text="$t('common.status')"
                        column-name="receivableState"
                        :enum-def="enumDef.allReceivablesState"
                        ref="filter_receivableState"
            ></EnumFilter>
            <TextFilter :label-text="this.$t('common.debtor')"
                        columnName="debtorName"
                        ref="filter_debtorName"
            ></TextFilter>
            <TextFilter :label-text="this.$t('common.invoiceNumber')"
                        columnName="invoiceNumber"
                        ref="filter_invoiceNumber"
            ></TextFilter>
            <FromToFilter :label-text="this.$t('common.amount')"
                          columnName="amount"
                          ref="filter_amount"
            ></FromToFilter>
            <CurrencyFilter columnName="currency"
                            ref="filter_currency"
            ></CurrencyFilter>
            <DateFilter :label-text="this.$t('common.dueDate')"
                        columnName="dueDate"
                        ref="filter_dueDate"
            ></DateFilter>
            <DateFilter :label-text="this.$t('common.invoiceDate')"
                        columnName="invoiceDate"
                        ref="filter_invoiceDate">

            </DateFilter>
        </div>
        <div class="filter_item">
            <div class="filter_head">{{this.$t("common.assignment")}}</div>
            <TextFilter :label-text="this.$t('common.investor')"
                        columnName="buyerName"
                        ref="filter_buyerName"
            ></TextFilter>
            <TextFilter :label-text="this.$t('common.transactionCode')"
                        columnName="transactionCode"
                        :sanitize="sanitizeTransactionCode"
                        ref="filter_transactionCode"
            ></TextFilter>
            <EnumFilter :label-text="$t('common.transactionType')"
                        column-name="transactionType"
                        :enum-def="enumDef.transactionType"
                        ref="filter_transactionType"
            ></EnumFilter>
            <EnumFilter :label-text="$t('common.assignmentType')"
                        column-name="postTrade"
                        :enum-def="enumDef.postTradeType"
                        ref="filter_postTrade"
            ></EnumFilter>
            <FromToFilter :label-text="this.$t('common.price')"
                          columnName="price"
                          ref="filter_price"
            ></FromToFilter>
            <FromToFilter :label-text="this.$t('common.roi')"
                          columnName="roi"
                          ref="filter_roi"
            ></FromToFilter>
<!--            <DateFilter :label-text="this.$t('common.date')"-->
<!--                        columnName="assignmentDate"-->
<!--                        ref="filter_assignmentDate"-->
<!--            ></DateFilter>-->
        </div>
        <div class="filter_item">
            <div class="filter_head">{{this.$t("seller.receivables.table.header.repayments")}}</div>
            <FromToFilter :label-text="this.$t('common.outstanding')"
                          columnName="outstandingPercent"
                          ref="filter_outstandingPercent"
            ></FromToFilter>
            <FromToFilter :label-text="this.$t('common.latePaymentDays')"
                          columnName="latePaymentDays"
                          ref="filter_latePaymentDays"
            ></FromToFilter>
        </div>
    </TableFilter>
</template>

<script>
import {enumDef} from "@/common/enumDefs";
import EnumFilter from "@/components/newFilter/EnumFilter";
import DateFilter from "@/components/newFilter/DateFilter";
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import CurrencyFilter from "@/components/newFilter/CurrencyFilter";
import TableFilter from "@/components/newFilter/TableFilter";

export default {
    components: {
        TableFilter,
        EnumFilter,
        FromToFilter,
        DateFilter,
        TextFilter,
        CurrencyFilter
    },
    data() {
        return {
            enumDef: enumDef,
        };
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        },
        sanitizeTransactionCode(value) {
            if (value) {
                return value.replace("TB-", "");
            }
        },
    }
};
</script>
